import React, { useState, useEffect } from "react";
import RightArrow from "../../../../../assets/images/RightArrow@2x.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../CustomComponents/Loader";
import { width } from "../../../../CustomComponents/DynamicCard/DynamicCardStyles";
import CustomTextInput from "../../../../CustomComponents/CustomtextInput";
import DynamicCard from "../../../../CustomComponents/DynamicCard";
import { appTheme, decimalValidation } from "../../../../../helpers/utils/Utils";
import {
  addLineBreaks,
  handleAmountInputLimitTo2decimal,
  handleAmountInputLimitTo2decimalForAmount,
  retrieveData,
} from "../../../../../utils";
import logFirebaseEvents from "../../../../LogFirebaseEvents";
import CardHeading from "../../../../CustomComponents/CardHeading";
import { use } from "react";
import { withOidcSecure } from "@axa-fr/react-oidc";
import {
  ADD_SAVING_GOALS,
  SAVING_CARD_CODE,
  STATUS_SUCCESS_CODE,
} from "../../../../../network/URLConstants";
import {
  GetApiHeadersWithBearer,
  PostRequest,
} from "../../../../../network/NetworkUtils";
import CustomDatePicker from '../../../../CustomComponents/CustomDateInput'
 
const SavingGoalDateField = ({
  cardFooter,
  onBack,
  onNext,
  handleAmountInput,
  onSave,
  onSetSpendSenseAlertFun,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
  const [amountError, setAmountError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isNext, setIsNext] = useState(true);
  const [amountValue, setAmountValue] = useState("");
  const accessTokenToApi = useSelector((state) => state.accessToken);
  const cards = useSelector((state) => JSON.parse(state.userCards));
  const amount = useSelector((state) => state.savingGoals.amount);
  const name = useSelector((state) => state.savingGoals.name);
  const date = useSelector((state) => state.savingGoals.targetDate);
  const RESmsg = useSelector((state) => state.savingGoalResonseMsg);
  const [responseMsg, setResponseMsg] = useState();
 
  const handleBackClick = () => {
    logFirebaseEvents(
      "Saving_Goals",
      "Back_Saving_Goals_Clicked",
      "Back_Saving_Goals_Clicked",
      "",
      ""
    );
    onBack("SavingGoalAmountField");
  };
 

 
 
const handleNextClick = () => {
    logFirebaseEvents("Saving_Goals", "Next_Saving_Goals_Clicked", "Next_Saving_Goals_Clicked","", "")
     onNext("SavingGoalNotificationField");
    dispatch({ type: 'SAVING_GOALS', payload: { key: "notificationArray", value: [] } });
  }
 
  const onDateChange = (date) => {
    dispatch({ type: 'SAVING_GOALS', payload: { 'key': "targetDate", 'value': date } })
  }
 
  // useEffect(() => {
  //   dispatch({ type: "SAVING_GOALS", payload: { key: "Amount", value: "" } });
  // }, []);
 
  
 
  const children = () => {
    return (
      <>
        {/* {cardHeader} */}
        <div
          className="sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
         sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
              text-[var(--text-clrs)] mt-6 sm:mx-0 mx-4"
        >
          {t("spending_alert_date_content1")} {" "}
          <span className="text-[var(--text-body-clrs)]">
            {addLineBreaks(t("Set_Target_Date"))}
          </span>
            <div className='font-hanken-grotesk mt-5 font-[300] md:text-[18px] sm:text-[12px] text-[14px] sm:leading-[18px] md:leading-[24px] leading-[25px] text-[var(--modal-text-heading-clr)]'>{addLineBreaks(t('Set_Target_Date_Subtext'))}</div>
        </div>
 
        <div className="w-full flex justify-center">
          <div className="sm:w-[80%] w-full">
            {/* BODY */}
            <div className="md:my-32 sm:my-16 mb-[10rem] sm:mx-0 mx-4">
              <div className="sm:w-[80%] w-full flex flex-col justify-center">
              <CustomDatePicker
                   selectedDate={date}
                    onDateChange={(date) => onDateChange(date)}
                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                    // minDate={new Date()}
                    // maxDate={''}
                    placeHolder={t('Month_Day_Year')}
                    disabledDates={[]}
                    title="Target Date (OPTIONAL)"
                    hrbg="bg-dropdown-sky"
                  />
              </div>
            </div>
          </div>
        </div>
        {/* FOOTER */}
 
        {cardFooter(handleBackClick, handleNextClick, "", "", isNext)}
      </>
    );
  };
  return (
    <>
      <DynamicCard
        header={false}
        CardRadius={true}
        cardWidth={width.homeCard}
        HeaderRadius={true}
        isWhite={appThemeData.isWhiteBgForCard}
        isDarkForKudzu={appThemeData.isDarkBgForCard}
        backgroundColor={"--cardHeading-bg"}
        HeaderContent={
          <>
            <CardHeading heading={t("Add_Saving_Goal")} />
          </>
        }
        footer={true}
      >
        {children()}
      </DynamicCard>
 
      {isLoading && <Loader />}
    </>
  );
};
 
export default withOidcSecure(SavingGoalDateField);